import { render, staticRenderFns } from "./UIActions.vue?vue&type=template&id=3d836cae&scoped=true&"
import script from "./UIActions.vue?vue&type=script&lang=js&"
export * from "./UIActions.vue?vue&type=script&lang=js&"
import style0 from "./UIActions.vue?vue&type=style&index=0&id=3d836cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d836cae",
  null
  
)

export default component.exports